import { ToastType } from '@components/toast';
import { underwritingTasksQueryKeys } from '@services/underwritingTasks/keys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { getApiErrorMessage } from '@utils/getApiErrorMessage';
import { useSnackbar } from 'notistack';

export const useRunUnderwritingRulesOnQuote = () => {
  const client = useClient();
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const mutationFn = async (quoteId: string) => client.post(`quote/${quoteId}/underwriting`);

  const result = useMutation({
    mutationFn,
    onSuccess: async () => {
      enqueueSnackbar('Ran underwriting successfully.', {
        variant: ToastType.Success,
        preventDuplicate: true,
      });
      // Refresh underwriting tasks and summary
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: underwritingTasksQueryKeys.all }),
        queryClient.invalidateQueries({ queryKey: ['underwritingTasksSummary'] }),
      ]);
    },
    onError: async (e) => {
      const message = await getApiErrorMessage(e, 'Failed to run underwriting.');
      enqueueSnackbar(message, {
        variant: ToastType.Error,
        preventDuplicate: true,
        persist: true,
      });
    },
  });

  return { ...result, runUnderwritingRulesOnQuote: result.mutateAsync };
};
